module.exports = __webpack_public_path__ + "static/media/healthy.5ed9e9f2.png";